<div mat-dialog-content class="form-container">
  <mat-horizontal-stepper [linear]="isLinear" #stepper [@.disabled]="true" class="stepsForm stepForm__contratista">
    <mat-step [stepControl]="datosCliente">
      <form [formGroup]="datosCliente" class="form__datosCentroContratista">
        <p class="warningCentro">Antes de dar de Alta un Centro Productor, por favor asegúrese de haber dado de alta previamente a sus Gestores y Transportistas.</p>
        <h1>Asignación Cliente</h1>

        <h2>Clientes e Instalaciones</h2>
        <div class="datos__datos">
          <p *ngIf="clienteSeleccionado" style="color: red;">Al cliente le quedan {{contadorLicencia}} licencia(s) por asignar a un centro</p>
          <mat-form-field appearance="outline">
            
            <mat-label>Asignar Cliente</mat-label>
            <mat-select name="cliente" [(value)]="clienteSeleccionado" (selectionChange)="selectCliente($event.value)" formControlName="cliente">
              <mat-option *ngFor="let cliente of clientes" [value]="cliente.id" >
             {{cliente.nombreComercial}}
              
              </mat-option>
            
          </mat-select>
          </mat-form-field>
          
          <ng-container *ngIf="instalaciones?.length > 0">
             <mat-form-field appearance="outline">
              <mat-label>Instalaciones del cliente</mat-label>
              <mat-select formControlName="instalacion" multiple>
                <mat-option (click)="selectAllInstalaciones($event)"><strong>Todas las instalaciones</strong></mat-option>
                <mat-option *ngFor="let instalacion of instalaciones" [value]="instalacion.id" #matOption (click)="selectInstalacion(matOption)">{{instalacion.nombre}}</mat-option>
              </mat-select>
            </mat-form-field>
          </ng-container>
          <ng-container *ngIf="instalaciones?.length == 0">
            <mat-form-field appearance="outline">
              <mat-label>Instalaciones del cliente</mat-label>
              <mat-select formControlName="instalacion" multiple>
                <mat-option  [value]="null" #matOption (click)="selectInstalacion(matOption)">No tiene Instalaciones</mat-option>
              </mat-select>
            </mat-form-field>
         </ng-container>
        </div>
      </form>
      <div class="boton__siguiente">
        <button mat-button matStepperNext [disabled]="datosCliente.invalid">
          Siguiente
        </button>
      </div>
    </mat-step>
    <mat-step [stepControl]="datosCentro">
      <form [formGroup]="datosCentro" class="form__datosCentroContratista">
        <h1>Alta Centro Productor</h1>
        <h2>Datos del Centro Productor</h2>
        <div class="datos__datos">
          <mat-form-field appearance="outline">
            <mat-label>Denominación</mat-label>
            <input matInput placeholder="Denominación" formControlName="nombre" required />
          </mat-form-field>
        </div>

        <h2>Dirección del Centro</h2>
        <div class="datos__direccion">
          <mat-form-field appearance="outline" class="via">
            <mat-label>Tipo de vía</mat-label>
            <mat-select placeholder="vía" formControlName="via" required> 
              <mat-option value="Calle">Calle</mat-option>
              <mat-option value="Avenida">Avenida</mat-option>
              <mat-option value="Paseo">Paseo</mat-option>
              <mat-option value="Plaza">Plaza</mat-option>
              <mat-option value="Otro">Otro</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" class="nombre">
            <mat-label>Nombre de la vía</mat-label>
            <input matInput placeholder="Nombre de la vía" formControlName="nombreVia" required/>
          </mat-form-field>

          <div class="datos">
            <mat-form-field appearance="outline">
              <mat-label>Nº</mat-label>
              <input matInput placeholder="Nº" formControlName="numero" required/>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Pta.</mat-label>
              <input matInput placeholder="Pta" formControlName="pta" />
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Letra</mat-label>
              <input matInput placeholder="letra" formControlName="letra" />
            </mat-form-field>
          </div>

          <mat-form-field appearance="outline">
            <mat-label>Provincia</mat-label>
            <mat-select formControlName="provincia">
              <mat-option *ngFor="let provincia of provincias" [value]="provincia" #matOption (click)="selectProvincia(matOption)">
                {{provincia.NOMBRE}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline"  *ngIf="autonomia">
            <mat-label>Comunidad Autónoma</mat-label>
            <input
              matInput
              placeholder="Comunidad Autónoma"
              formControlName="ccaa"
              required
              [(ngModel)]="autonomia"
            />
            <mat-error>Campo Obligatorio</mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Código Postal</mat-label>
            <input matInput placeholder="Código Postal" formControlName="cp" required />
          </mat-form-field>
        </div>

        <div>
          <h2>Información de Contacto</h2>
          <div class="infoContacto">
            <mat-form-field appearance="outline">
              <mat-label>Nombre y apellido de Contacto</mat-label>
              <input matInput placeholder="Nombre y apellido" formControlName="nombreContacto" required />
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Mail de Contacto</mat-label>
              <input matInput placeholder="mail" formControlName="mailContacto" required />
            </mat-form-field>
          </div>
        </div>
        <div class="boton__siguiente">
          <button mat-button matStepperNext [disabled]="datosCentro.invalid">
            Siguiente
          </button>
        </div>
      </form>
    </mat-step>

    <mat-step [stepControl]="datosCentro2">
      <form [formGroup]="datosCentro2">
        <h1>Alta Centro Productor</h1>
        <h2>Datos de Gestión del Centro Productor</h2>
        <div>
          <mat-form-field appearance="outline" class="nima">
            <mat-label>NIMA</mat-label>
            <input matInput placeholder="Nima" formControlName="nima" required />
          </mat-form-field>
        </div>

        <div class="radio__residuos" >
          <label>¿Produce Residuos Peligrosos?</label>
          <div class="radioButton">
            <div>
              <input type="radio" formControlName="resPeligrosos" [value]="true" id="sir" checked/>
              <label for="sir">Sí</label>
            </div>
            <div *ngIf="!residuosPeligrosos">
              <input type="radio" formControlName="resPeligrosos" [value]="false" id="nor" />
              <label for="nor">No</label>
            </div> 
          </div>
        </div>

        <!-- <div class="radio__residuos" *ngIf="residuosPeligrosos">
         <p style="color: red;">El cliente seleccionado ha indicado que es productor de residuos peligrosos, en el siguiente paso los documentos "Comunicación actividad productora Residuos Peligrosos" y "Comunicación actividad productora Residuos No Peligrosos"
          son obligatorios.</p> 
        </div> -->

        <div class="radio__residuos">
          <label>¿Es Gran Productor de Residuos NO Peligrosos?</label>
          <div class="radioButton">
            <div>
              <input type="radio" formControlName="GPResPeligrosos" [value]="true" id="sirp" />
              <label for="sirp">Sí</label>
            </div>
            <div>
              <input type="radio" formControlName="GPResPeligrosos" [value]="false" id="norp" />
              <label for="norp">No</label>
            </div>
          </div>
        </div>
        <h2>Selección de Gestores y Transportistas</h2>
        <!-- Controlar que no puedan continuar si no tienen gestores y transportistas dados de alta -->
        <ng-container *ngIf="!gestoresContratista || gestoresContratista.length === 0">
          <p style="color: red;">Por favor, debe dar de Alta previamente a sus Gestores para continuar</p>
        </ng-container>
        <ng-container *ngIf="!transportistasContratista || transportistasContratista.length === 0">
          <p style="color: red;">Por favor, debe dar de Alta previamente a sus Transportistas para continuar</p>
        </ng-container>
        <ng-container *ngIf="gestoresContratista?.length > 0">
        <mat-form-field appearance="outline">
          <mat-label>Gestores</mat-label>
          <mat-select formControlName="gestores" multiple> 
            <mat-option (click)="selectAllGestores($event)" ><strong>Todos los gestores</strong></mat-option>
            <mat-option *ngFor="let gestor of gestoresContratista" [value]="gestor.id" #matOption (click)="selectGestores(matOption)">{{gestor.nombre}}</mat-option>
          </mat-select>
        </mat-form-field>
      </ng-container>
      <ng-container *ngIf="transportistasContratista?.length > 0">
        <mat-form-field appearance="outline">
          <mat-label>Transportistas</mat-label>
          <mat-select formControlName="transportistas" multiple> 
            <mat-option (click)="selectAllTransportistas($event)" ><strong>Todos los transportistas</strong></mat-option>
            <mat-option *ngFor="let transportista of transportistasContratista" [value]="transportista.id" #matOption (click)="selectTransportistas(matOption)">{{transportista.nombre}}</mat-option>
          </mat-select>
        </mat-form-field>
      </ng-container>

        <div class="boton__pasos">
          <div class="boton__siguiente">
            <button mat-button matStepperNext [disabled]="datosCentro2.invalid">
              Siguiente
            </button>
          </div>
        </div>
      </form>
    </mat-step>

    <mat-step [stepControl]="datosDocumento1">

      <h2>Documentación</h2>

      <div class="documentos-form">
        <h3>Comunicación actividad productora Residuos Peligrosos<span *ngIf="datosCentro2.value.resPeligrosos || residuosPeligrosos"><strong style="color: red;"><br> *Documento Obligatorio</strong></span></h3>
        <div class="docpropia__drop">
          <ngx-file-drop dropZoneClassName="drop" contentClassName="drop_content" dropZoneLabel="Drop files here"
            (onFileDrop)="dropped1($event)" (onFileOver)="fileOver($event)" (onFileLeave)="fileLeave($event)" >
            <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
              <ng-container *ngIf="nameDocumento1">{{nameDocumento1}}</ng-container>
              <ng-container *ngIf="!nameDocumento1">Puedes soltar aquí los documentos o</ng-container>
              <button type="button" class="boton_drop" (click)="openFileSelector()" id="doc1" (click)="setValue($event)" >Seleccionar un archivo</button>
            </ng-template>
          </ngx-file-drop>
        </div>
        <div>
          <form [formGroup]="datosDocumento1">
            <mat-form-field appearance="outline" class="example-form-field">
              <mat-label>Fecha de Emisión</mat-label>
              <input matInput required formControlName="fechaValidez" [matDatepicker]="datepicker">
              <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
              <mat-datepicker #datepicker>
                <mat-datepicker-actions>
                  <button mat-button matDatepickerCancel>Cancelar</button>
                  <button mat-raised-button color="primary" matDatepickerApply>Hecho</button>
                </mat-datepicker-actions>
              </mat-datepicker>
            </mat-form-field>
          </form>
        </div>
      </div>

      <div class="documentos-form">
        <h3>Comunicación actividad productora Residuos No Peligrosos<span *ngIf="datosCentro2.value.GPResPeligrosos"><strong style="color: red;"><br> *Documento Obligatorio</strong></span></h3>
        <div class="docpropia__drop">
          <ngx-file-drop dropZoneClassName="drop" contentClassName="drop_content" dropZoneLabel="Drop files here"
            (onFileDrop)="dropped2($event)" (onFileOver)="fileOver($event)" (onFileLeave)="fileLeave($event)" >
            <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
              <ng-container *ngIf="nameDocumento2">{{nameDocumento2}}</ng-container>
              <ng-container *ngIf="!nameDocumento2">Puedes soltar aquí los documentos o</ng-container>
              <button type="button" class="boton_drop" (click)="openFileSelector()" id="doc2" (click)="setValue($event)">Seleccionar un archivo</button>
            </ng-template>
          </ngx-file-drop>
        </div>
        <div>
          <form [formGroup]="datosDocumento2">
            <mat-form-field appearance="outline" class="example-form-field">
              <mat-label>Fecha de Emisión</mat-label>
              <input matInput required formControlName="fechaValidez" [matDatepicker]="datepicker2">
              <mat-datepicker-toggle matSuffix [for]="datepicker2"></mat-datepicker-toggle>
              <mat-datepicker #datepicker2>
                <mat-datepicker-actions>
                  <button mat-button matDatepickerCancel>Cancelar</button>
                  <button mat-raised-button color="primary" matDatepickerApply>Hecho</button>
                </mat-datepicker-actions>
              </mat-datepicker>
            </mat-form-field>
          </form>
        </div>
      </div>

      <!-- <div class="documentos-form">
        <h3>Informe Trimestral de residuos</h3>
        <div class="docpropia__drop">
          <ngx-file-drop dropZoneClassName="drop" contentClassName="drop_content" dropZoneLabel="Drop files here"
            (onFileDrop)="dropped3($event)" (onFileOver)="fileOver($event)" (onFileLeave)="fileLeave($event)" >
            <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
              <ng-container *ngIf="nameDocumento3">{{nameDocumento3}}</ng-container>
          <ng-container *ngIf="!nameDocumento3">Puedes soltar aquí los documentos o</ng-container>
              <button type="button" class="boton_drop" (click)="openFileSelector()" id="doc3" (click)="setValue($event)">Seleccionar un archivo</button>
            </ng-template>
          </ngx-file-drop>
        </div>
        <div>
          <form [formGroup]="datosDocumento3">
            <mat-form-field appearance="outline" class="example-form-field">
              <mat-label>Fecha de Emisión</mat-label>
              <input matInput required formControlName="fechaValidez" [matDatepicker]="datepicker6">
              <mat-datepicker-toggle matSuffix [for]="datepicker6"></mat-datepicker-toggle>
              <mat-datepicker #datepicker6>
                <mat-datepicker-actions>
                  <button mat-button matDatepickerCancel>Cancelar</button>
                  <button mat-raised-button color="primary" matDatepickerApply>Hecho</button>
                </mat-datepicker-actions>
              </mat-datepicker>
            </mat-form-field> -->
            <!-- <div class="caducidad">
              <div>
                <mat-form-field appearance="outline" class="example-form-field">
                  <mat-label>Fecha de Caducidad</mat-label>
                  <input matInput formControlName="fechaCaducidad" [matDatepicker]="datepicker7">
                  <mat-datepicker-toggle matSuffix [for]="datepicker7"></mat-datepicker-toggle>
                  <mat-datepicker #datepicker7>
                    <mat-datepicker-actions>
                      <button mat-button matDatepickerCancel>Cancelar</button>
                      <button mat-raised-button color="primary" matDatepickerApply>Hecho</button>
                    </mat-datepicker-actions>
                  </mat-datepicker>
                </mat-form-field>
              </div>
              <div>
                <div class="radio__caduca">
                  <div>
                    <input type="radio" [value]=true id="si" formControlName="noCaduca" />
                    <label for="si">No caduca</label>
                  </div>
                </div>
              </div>
            </div> -->

      <div class="documentos-form">
        <h3>Contrato de tratamiento o autorización de operador</h3>
        <div class="docpropia__drop">
          <ngx-file-drop dropZoneClassName="drop" contentClassName="drop_content" dropZoneLabel="Drop files here"
            (onFileDrop)="dropped4($event)" (onFileOver)="fileOver($event)" (onFileLeave)="fileLeave($event)"  >
            <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
              <ng-container *ngIf="nameDocumento4">{{nameDocumento4}}</ng-container>
              <ng-container *ngIf="!nameDocumento4">Puedes soltar aquí los documentos o</ng-container>
              <button type="button" class="boton_drop" (click)="openFileSelector()" id="doc4" (click)="setValue($event)">Seleccionar un archivo</button>
            </ng-template>
          </ngx-file-drop>
        </div>

        <div>
          <form [formGroup]="datosDocumento4">
            <mat-form-field appearance="outline" class="example-form-field">
              <mat-label>Fecha de Emisión</mat-label>
              <input matInput required formControlName="fechaValidez" [matDatepicker]="datepicker4">
              <mat-datepicker-toggle matSuffix [for]="datepicker4"></mat-datepicker-toggle>
              <mat-datepicker #datepicker4>
                <mat-datepicker-actions>
                  <button mat-button matDatepickerCancel>Cancelar</button>
                  <button mat-raised-button color="primary" matDatepickerApply>Hecho</button>
                </mat-datepicker-actions>
              </mat-datepicker>
            </mat-form-field>
            <div>
              <mat-form-field appearance="outline" class="example-form-field">
                <mat-label>Fecha de Caducidad</mat-label>
                <input matInput formControlName="fechaCaducidad" [matDatepicker]="datepicker10">
                <mat-datepicker-toggle matSuffix [for]="datepicker10"></mat-datepicker-toggle>
                <mat-datepicker #datepicker10>
                  <mat-datepicker-actions>
                    <button mat-button matDatepickerCancel>Cancelar</button>
                    <button mat-raised-button color="primary" matDatepickerApply>Hecho</button>
                  </mat-datepicker-actions>
                </mat-datepicker>
              </mat-form-field>
            </div>          
     
            <div class="privacidad2">
              <input type="checkbox" id="privacidad" formControlName="policy"/>
              <label for="privacidad" id="privacidad" > He leido y acepto la <a href="https://xtensa.es/politica/"  target="_blank">Politica de Privacidad</a></label>
              <p id="proteccion">
                El responsable del tratamiento de los datos es INPRONET SOLUTIONS SL. La finalidad de la recogida de datos es la de poder atender sus cuestiones, sin ceder sus datos a terceros. Tiene derecho a saber qué información tenemos sobre usted, corregirla o eliminarla tal y como se explica en nuestra Política de Privacidad.</p>
            </div>
          </form>
        </div>
      </div>
       
     <!--  <div class="documentos-form">
        <h3>Declaración de residuos(si aplica)</h3>
        <div class="docpropia__drop">
          <ngx-file-drop dropZoneClassName="drop" contentClassName="drop_content" dropZoneLabel="Drop files here"
            (onFileDrop)="dropped($event)" (onFileOver)="fileOver($event)" (onFileLeave)="fileLeave($event)" >
            <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
              Puedes soltar aquí los documentos o
              <button type="button" class="boton_drop" (click)="openFileSelector()" id="doc5" (click)="setValue($event)">Seleccionar un archivo</button>
            </ng-template>
          </ngx-file-drop>
        </div>
        <div>
          <form [formGroup]="datosDocumento5">
            <mat-form-field appearance="outline" class="example-form-field">
              <mat-label>Fecha de Emisión</mat-label>
              <input matInput required formControlName="fechaValidez" [matDatepicker]="datepicker8">
              <mat-datepicker-toggle matSuffix [for]="datepicker8"></mat-datepicker-toggle>
              <mat-datepicker #datepicker8>
                <mat-datepicker-actions>
                  <button mat-button matDatepickerCancel>Cancelar</button>
                  <button mat-raised-button color="primary" matDatepickerApply>Hecho</button>
                </mat-datepicker-actions>
              </mat-datepicker>
            </mat-form-field>
            <div class="caducidad">
              <div>
                <mat-form-field appearance="outline" class="example-form-field">
                  <mat-label>Fecha de Caducidad</mat-label>
                  <input matInput formControlName="fechaCaducidad" [matDatepicker]="datepicker9">
                  <mat-datepicker-toggle matSuffix [for]="datepicker9"></mat-datepicker-toggle>
                  <mat-datepicker #datepicker9>
                    <mat-datepicker-actions>
                      <button mat-button matDatepickerCancel>Cancelar</button>
                      <button mat-raised-button color="primary" matDatepickerApply>Hecho</button>
                    </mat-datepicker-actions>
                  </mat-datepicker>
                </mat-form-field>
              </div>
              <div>
                <div class="radio__caduca">
                  <div>
                    <input type="radio" [value]=true id="si" formControlName="noCaduca" />
                    <label for="si">No caduca</label>
                  </div>
                </div>
              </div>
            </div>

          </form>
        </div>
      </div>  -->
      
      <div class="boton__pasos">
        <button matStepperPrevious>Anterior</button>
        <button type="submit" (click)="addCentro()" [mat-dialog-close] [disabled]="datosCentro2.invalid">
          Hecho
        </button>
      </div>

    </mat-step>
  </mat-horizontal-stepper>
</div>